import 'sbf-design-system-component/broadcast_messages/broadcast_message';

$(function () {
  // BUSINESS ADDRESS STUFF:

  const $forBusiness = $('#forBusiness');
  const $businessName = $('#businessName').closest('div');
  const $businessNameLabelHeading = $('label[for=businessName]');

  function toggleIsBusiness () {
    if ($forBusiness.prop('checked')) {
      $businessName.show();
      $businessNameLabelHeading.show();
    } else {
      $businessName.hide();
      $businessNameLabelHeading.hide();
    }
  }

  $forBusiness.bind('change', toggleIsBusiness);

  toggleIsBusiness();

  // COUNTRY / STATE / PROVINCE / POSTAL CODE STUFF:

  const $country = $('#country');
  const $city = $('#city');
  const $state = $('#state');
  const $region = $('#region');
  const $zipcode = $('#zipcode');

  if ($country.val() == '') {
    $country.val('US');
  }

  // error stuff

  // close error messages
  $('.alert.error button.close').bind('click', function (click) {
    click.preventDefault();
    $(this).parent().fadeOut(200);
  });

  let nameBlur = 0;
  $('#firstName, #lastName').bind('keydown', function () {
    nameBlur++;
    if (nameBlur == 1 && $.browser.msie) return false;
    $(this).removeClass('error'); // remove error highlight from input
    if ($('#firstName').val() != '' && $('#lastName').val() != '') {
      $('#name-alert').fadeOut(200);
    }
  });

  let emailBlur = 0;
  $('#email').bind('keydown', function () {
    emailBlur++;
    if (emailBlur == 1 && $.browser.msie) return false;
    if (/.+\@.+\..+/.test($(this).val())) {
      $('#email-alert').fadeOut(200);
      $(this).removeClass('error'); // remove error highlight from input
    }
  });

  // Only validate phone field if element is present
  if ($('#phone').length !== 0) {
    let phoneBlur = 0;
    $('#phone').bind('keydown', function () {
      phoneBlur++;
      if (phoneBlur == 1 && $.browser.msie) return false;
      if ($.trim($('#phone').val()) != '') {
        $('#phone-alert').fadeOut(200);
        $(this).removeClass('error'); // remove error highlight from input
      }
    });
  }

  let applySubmitProcessIEAddressBlurHack = false;
  $('#address1, #city, #state, #region, #zipcode, #country').bind('keydown', function () {
    if (
      $('#country').val() != '' &&
      $('#address1').val() != '' &&
      $('#city').val() != '' &&
      $('#zipcode').val() != '' &&
      (
        ($('#state').is(':visible') && $('#state').val() != '') ||
        $('#region').is(':visible')
      )
    ) {
      if (applySubmitProcessIEAddressBlurHack == true && $.browser.msie) {
        applySubmitProcessIEAddressBlurHack = false;
        return false;
      }

      // epically validate the address
      $('#address-alert').fadeOut(200);
      $('#address1').removeClass('error'); // remove error highlight from input
      $('#country').removeClass('error'); // remove error highlight from input
      $('#city').removeClass('error'); // remove error highlight from input
      $('#state').removeClass('error'); // remove error highlight from input
      $('#zipcode').removeClass('error'); // remove error highlight from input
    } else {
    }
  });

  $('#birthday').bind('sbf.dateChange', function () {
    if (/\d{4}-\d{2}-\d{2}/.test($(this).val())) {
      $('#birthday-alert').fadeOut(200);
      $('#sbf-datepicker-0-year').removeClass('error'); // remove error highlight from input
      $('#sbf-datepicker-0-month').removeClass('error'); /// remove error highlight from input
      $('#sbf-datepicker-0-day').removeClass('error'); // remove error highlight from input
    }
  });

  $('input[name=gender]').bind('click', function () {
    $('#gender-alert').fadeOut(200);
    $('.gender-option').removeClass('error'); // remove error highlight from input
  });

  $('#forBusiness').bind('click', function () {
    $('#businessName-alert').fadeOut(200);
    $('#businessName').removeClass('error'); // remove error highlight from input
    $('#forBusiness').removeClass('error'); // remove error highlight from input
  });

  $('#businessName').bind('keydown', function () {
    $('#businessName-alert').fadeOut(200);
    $('#businessName').removeClass('error'); // remove error highlight from input
    $('#forBusiness').removeClass('error'); // remove error highlight from input
  });

  $('#profile-create-form').bind('submit', function (submit) {
    applySubmitProcessIEAddressBlurHack = true;
    const submissionFieldset = $('#profile-submission');
    const submissionButton = $('#profile-create-submit');
    // prevent double click of submit button
    if (submissionFieldset.hasClass('loading')) {
      return false;
    }

    // add loading gif next to submit button
    submissionFieldset.addClass('loading');
    submissionButton.removeClass('inverse');
    $('#NextBtn').setDisabled(true);

    let is_valid = true;
    let first_error_location;

    // Populate placeholders on form error for placeholderfix.js hack
    $('input').blur();

    if ($.trim($('#firstName').val()) == '' || $.trim($('#firstName').val()) == 'First Name' ||
                    $.trim($('#lastName').val()) == '' || $.trim($('#lastName').val()) == 'Last Name') {
      $('#name-alert').fadeIn(200);
      if ($.trim($('#firstName').val()) == '' || $.trim($('#firstName').val()) == 'First Name') {
        $('#firstName').addClass('error'); // add error highlight to input
      }
      if ($.trim($('#lastName').val()) == '' || $.trim($('#lastName').val()) == 'Last Name') {
        $('#lastName').addClass('error'); // add error highlight to input
      }
      is_valid = false;
      if (!first_error_location) {
        first_error_location = '#name-alert';
      }
    }

    if (!/.*@.*\..*/.test($('#email').val())) {
      $('#email-alert').fadeIn(200);
      $('#email').addClass('error'); // add error highlight to input
      is_valid = false;
      if (!first_error_location) {
        first_error_location = '#email-alert';
      }
    }

    if ($.trim($('#phone').val()) == '') {
      $('#phone-alert').fadeIn(200);
      $('#phone').addClass('error'); // add error highlight to input
      is_valid = false;
      if (!first_error_location) {
        first_error_location = '#phone-alert';
      }
    }

    if (!/\d{4}-\d{2}-\d{2}/.test($('#birthday').val()) || sbf.datepicker.getDateObject($('#birthday').val()) === 'invalid') {
      $('#birthday-alert').fadeIn(200);
      $('#sbf-datepicker-0-year').addClass('error'); // add error highlight to input
      $('#sbf-datepicker-0-month').addClass('error'); // add error highlight to input
      $('#sbf-datepicker-0-day').addClass('error'); // add error highlight to input
      is_valid = false;
      if (!first_error_location) {
        first_error_location = '#birthday-alert';
      }
    }

    if (!$('input[name=gender]:checked').length) {
      $('#gender-alert').fadeIn(200);
      $('.gender-option').addClass('error'); // add error highlight to input
      is_valid = false;
      if (!first_error_location) {
        first_error_location = '#gender-alert';
      }
    }

    // Business name is required if checkbox is checked
    if ($('#forBusiness').is(':checked')) {
      if ($('#businessName').val() == '') {
        $('#businessName').addClass('error');
        $('#forBusiness').addClass('error');

        $('#businessName-alert').fadeIn(200);
        if (!first_error_location) {
          first_error_location = '#forBusiness';
        }
        is_valid = false;
      }
    }

    if (
      $.trim($('#address1').val()) == '' ||
      $.trim($('#address1').val()) == 'Address 1' ||
      $('#country').val() == '' ||
      $('#city').val() == '' ||
      $('#city').val() == 'City' ||
      (($('#country').val() == 'US' || $('#country').val() == 'CA') && ($('#state').val() == '' || $.trim($('#zipcode').val()) == '' || $.trim($('#zipcode').val()) == 'Zip Code'))
    ) {
      $('#address-alert').fadeIn(200);

      if ($.trim($('#address1').val()) == '' || $.trim($('#address1').val()) == 'Address 1') {
        $('#address1').addClass('error'); // add error highlight to input
      }

      if ($('#country').val() == '') {
        $('#country').addClass('error'); // add error highlight to input
      }

      if ($('#city').val() == '' || $('#city').val() == 'City') {
        $('#city').addClass('error'); // add error highlight to input
      }

      if ($('#country').val() == 'US' && $('#state').val() == '') {
        $('#state').addClass('error'); // add error highlight to input
      }

      if (($('#country').val() == 'US' || $('#country').val() == 'CA') && ($.trim($('#zipcode').val()) == '' || $.trim($('#zipcode').val()) == 'Zip Code')) {
        $('#zipcode').addClass('error'); // add error highlight to input
      }

      is_valid = false;
      if (!first_error_location) {
        first_error_location = '#address-alert';
      }
    }

    if (!is_valid) {
      submissionFieldset.find('input').attr('disabled', false);
      submissionFieldset.removeClass('loading'); // remove loading gif
      submissionButton.addClass('inverse');
    }

    if (!is_valid && first_error_location) {
      location.hash = first_error_location;
    } else {
      // Clear placeholder values for placeholderfix.js hack
      $(this).find('.placeholder_polyfill_applied').each(function () { $(this).val(''); });
    }

    return is_valid;
  });
});
